/* eslint-disable no-restricted-imports */

import {
  Box,
  Chip,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { FormatMoney } from 'components';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows[2],
  },
  boldText: {
    fontWeight: 600,
  },
  sellPrice: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  priceInput: {
    minWidth: 120,
  },
}));

export default function PricingStep({ orderItems, onUpdatePrice }) {
  const classes = useStyles();

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Definir Preços de Custo e Venda
      </Typography>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Produto</strong>
              </TableCell>
              <TableCell align='center'>
                <strong>Qtd</strong>
              </TableCell>
              <TableCell align='right'>
                <strong>Preço Custo (un)</strong>
              </TableCell>
              <TableCell align='right'>
                <strong>Preço Venda (un)</strong>
              </TableCell>
              <TableCell align='right'>
                <strong>Total Custo</strong>
              </TableCell>
              <TableCell align='right'>
                <strong>Total Venda</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderItems.map((item) => (
              <TableRow key={item.part_number} hover>
                <TableCell>
                  <Typography variant='body2' className={classes.boldText}>
                    {item.part_number}
                  </Typography>
                  <Typography variant='caption' color='textSecondary'>
                    {item.description}
                  </Typography>
                </TableCell>
                <TableCell align='center'>
                  <Chip label={item.quantity} size='small' />
                </TableCell>
                <TableCell align='right'>
                  <TextField
                    type='number'
                    variant='outlined'
                    size='small'
                    value={item.cost_price}
                    onChange={(e) => onUpdatePrice(item.part_number, 'cost_price', e.target.value)}
                    inputProps={{ min: 0, step: 0.01 }}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
                    }}
                    className={classes.priceInput}
                  />
                </TableCell>
                <TableCell align='right'>
                  <TextField
                    type='number'
                    variant='outlined'
                    size='small'
                    value={item.sell_price}
                    onChange={(e) => onUpdatePrice(item.part_number, 'sell_price', e.target.value)}
                    inputProps={{ min: 0, step: 0.01 }}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
                    }}
                    className={classes.priceInput}
                  />
                </TableCell>
                <TableCell align='right'>
                  <FormatMoney>{item.quantity * item.cost_price}</FormatMoney>
                </TableCell>
                <TableCell align='right'>
                  <Typography className={classes.sellPrice}>
                    <FormatMoney>{item.quantity * item.sell_price}</FormatMoney>
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

PricingStep.propTypes = {
  orderItems: PropTypes.array.isRequired,
  onUpdatePrice: PropTypes.func.isRequired,
};
